module.exports = __webpack_public_path__ + "img/print.d6955540.png";